/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


function albaDebounce(func) {
    var timer;
    return function(event) {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(func, 100, event);
    };
}

(function($) {

    /**
     * Universal click or tap event
     * (replacement for 'click')
     */

    var clickEvent = function () {
        return ('undefined' !== typeof window.touchstart ? 'touchstart' : 'click');
    };

    var winWidth = $(window).width(),
        xs       = false,
        sm       = false,
        md       = false,
        lg       = false;

    var isMenuEntered = false;

    /**
    * Mobile
    * Window width
    */

    function mobileCheck() {
        if ( winWidth >= '992' ) {
            lg = true;
            md = false;
            sm = false;
            xs = false;
        } else if ( winWidth >= '768' ) {
            lg = false;
            md = true;
            sm = false;
            xs = false;
        } else if ( winWidth >= '576' ) {
            lg = false;
            md = false;
            sm = true;
            xs = false;
        } else {
            lg = false;
            md = false;
            sm = false;
            xs = true;
        }
    }

    mobileCheck();

    $(window).resize(function() {
        winWidth = $(window).width();
        mobileCheck();
    });

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Delta = {
        // All pages
        'common': {

            init: function() {
                // JavaScript to be fired on all pages

                /**
                 * Site header
                 */

                var siteHeaderStyle = function() {
                    if ( 10 <= $(document).scrollTop() ) {
                        $('#site-header').addClass('is-not-top');
                    } else {
                        $('#site-header').removeClass('is-not-top');
                    }
                };

                siteHeaderStyle();

                $(window).on('scroll', function() {
                    siteHeaderStyle();
                });


                /**
                 * Site nav
                 */

                var menu = new MmenuLight(
                    document.querySelector('#mobile-menu'),
                    'all'
                );

                $('#mobile-menu').show();

                var navigator = menu.navigation({
                    'title': 'Menu',
                    'slidingSubmenus': false
                    // selectedClass: 'Selected',
                    // theme: 'dark',
                });

                var drawer = menu.offcanvas({
                    position: 'right'
                });

                var closePrimaryNavSubMenus = function($this) {
                    if ( ! $this ) {
                        $('#menu-primary .sub-menu-active').removeClass('sub-menu-active');
                        $('#menu-primary .sub-menu').velocity('slideUp');
                    } else {
                        $('#menu-primary .sub-menu-active').not($this).removeClass('sub-menu-active');
                        $('#menu-primary .sub-menu').not($this.children('.sub-menu'))
                            .velocity('slideUp');
                    }
                },

                openPrimaryNavSubMenus = function($this) {
                    closePrimaryNavSubMenus($this);

                    $this.addClass('sub-menu-active');

                    $this.children('.sub-menu')
                        .velocity('slideDown');
                },

                closePrimaryNav = function() {
                    closePrimaryNavSubMenus();
                    $('body').removeClass('mobile-nav-is-active');
                    $('#site-nav .mobile-nav-trigger')
                        .removeClass('active');
                    // $('#site-nav .mobile-nav-trigger').children('i')
                    //     .removeClass('la-close')
                    //     .addClass('la-navicon');

                    if (!lg) {
                    //   $('.menu-primary-container').velocity('slideUp', { duration: 150 });
                        drawer.close();
                    }
                },

                openPrimaryNav = function() {
                    $('body').addClass('mobile-nav-is-active');
                    $('#site-nav .mobile-nav-trigger')
                        .addClass('active');
                    // $('#site-nav .mobile-nav-trigger').children('i')
                    //     .removeClass('la-navicon')
                    //     .addClass('la-close');

                    if (!lg) {
                        // $('.menu-primary-container').velocity('slideDown', { duration: 250 });
                        drawer.open();
                    }
                };

                adjustSubMenuWidthAndPosition = function(subMenu) {
                    if (!subMenu) {
                        return;
                    }

                    var w = $(window).width();
                    // console.log('adjustSubMenuWidthAndPosition: ', w, subMenu);
                    if (lg && subMenu.parent() && subMenu.parent().offset()) {
                        subMenu.css('left', '-' + subMenu.parent().offset().left + 'px');
                        subMenu.css('width', w + 'px');
                    } else {
                        subMenu.css('left', '').css('width', '');
                    }
                    if (w > 1140) {
                        var p = (w - 1140) / 2;
                        p += 15; // Add normal bootstrap container padding.
                        // console.log("hi", subMenu.offset().left, w, p);
                        subMenu.css('padding-left', p + 'px').css('padding-right', p + 'px');
                    } else {
                        subMenu.css('padding-left', '').css('padding-right', '');
                    }
                };

                /* Not mobile */

                if ( lg ) {

                    $(document).on({
                        mouseenter: function(e) {
                            var subMenu = $(this).children('.sub-menu');
                            adjustSubMenuWidthAndPosition(subMenu);

                            // subMenu.stop(true, true).css('height', '').velocity('slideDown', { duration: 250, display: 'flex' });
                            // subMenu.stop(true, true).css('height', '').css('display', 'flex').animate('slideDown', { duration: 250});
                            subMenu.stop(true, true).css('height', '').css('display', 'flex')/*.slideDown('slow')*/;
                            e.stopPropagation();
                        },
                        mouseleave: function(e) {
                            $(this).children('.sub-menu').stop(true, true).slideUp();
                            // $(this).children('.sub-menu').stop(true, true).velocity('slideUp', { duration: 150 });
                            e.stopPropagation();
                        }
                    }, '#menu-primary > li.menu-item');

                }

                /* Mobile */

                // Open

                $(document).on(clickEvent(), '#site-nav .mobile-nav-trigger', function(e) {
                    e.preventDefault();
                    if ( ! $('body').hasClass('mobile-nav-is-active') ) {
                        openPrimaryNav();
                    }
                });

                setInterval(function() {
                    if (jQuery('.mm-ocd--open').length > 0) {
                        $('body').addClass('mobile-nav-is-active');
                    } else {
                        $('body').removeClass('mobile-nav-is-active');
                    }
                }, 500);

                // Close on body click

                // $(document).on(clickEvent(), 'body.mobile-nav-is-active', function(e) {
                //     if ( $(e.target) !== $('#menu-primary') &&
                //         ! $(e.target).parents('#menu-primary').length ) {
                //         closePrimaryNav();
                //         closePrimaryNavSubMenus();
                //     }
                // });

                // Change mm-spn items to minus when open.
                // This handles the top level items.
                $('.mm-spn li.menu-item-has-children').click(function(e) {
                    // Ignore parent clicks when the sub-menu items are clicked.
                    var t = new Date().getTime();
                    if ((t - window.lastMMSpnClicked) < 100) {
                        return;
                    } else {
                        window.lastMMSpnClicked = t;
                    }

                    var topLevelLi = $(this).parent().hasClass('menu');
                    var subMenuOpen = $(this).find('> .sub-menu').hasClass('mm-spn--open');
                    // var ourIsOpen =
                    console.log('topLevel=' + topLevelLi + ', sub-menu is open=' + subMenuOpen);
                    if (!subMenuOpen) {
                        if (topLevelLi) {
                            // Opening another top level menu so add plus to everything.
                            $('.mm-spn li').removeClass('is-open');
                        } else {
                            // Opening another sub level menu so add plus to any peer menus.
                            $(this).parent().find('li').removeClass('is-open');
                        }
                        $(this).addClass('is-open');
                    } else {
                        $(this).removeClass('is-open');
                        $(this).find('.sub-menu li').removeClass('is-open');
                    }
                });

                // Submenu expand

                if ( ! lg ) {

                    $(document).on(clickEvent(), '.menu-item-has-children .expand', function(e) {
                        if ( ! $(this).parent().hasClass('sub-menu-active') ) {
                            closePrimaryNavSubMenus($(this).parent());
                            openPrimaryNavSubMenus($(this).parent());
                        } else {
                            closePrimaryNavSubMenus();
                        }
                    });

                }


                /**
                 * Site search
                 */
/*
                var closeSearch = function() {
                    $('body').removeClass('search-is-active');
                    $('#site-search input.search-field').blur();
                    $('#menu-primary .menu-item.search').find('i')
                        .removeClass('la-close')
                        .addClass('la-search');
                },

                openSearch = function() {
                    $('body').addClass('search-is-active');
                    $('#site-search input.search-field').focus();
                    $('#menu-primary .menu-item.search').find('i')
                        .removeClass('la-search')
                        .addClass('la-close');
                },
*/
                var closeMobileSearch = function() {
                    $('body').removeClass('mobile-search-is-active');
                    // $('#site-nav .mobile-search-trigger').children('i')
                    //     .removeClass('la-close')
                    //     .addClass('la-search');
                },

                openMobileSearch = function() {
                    $('body').addClass('mobile-search-is-active');
                    // $('#site-nav .mobile-search-trigger').children('i')
                    //     .removeClass('la-search')
                    //     .addClass('la-close');
                };

                // Not mobile

                // $(document).on(clickEvent(), '#menu-primary .menu-item.search a', function(e) {
                //     e.preventDefault();
                //     openSearch();
                // });

                // $(document).on(clickEvent(), 'body.search-is-active', function(e) {
                //     if ( ! $(e.target).parents('#site-search').length ||
                //         $(e.target).parents('#site-search .close').length
                //     ) {
                //         closeSearch();
                //     }
                // });

                $('.menu-item-4330').click(function(e) {
                    e.preventDefault();
                    $('.searchandfilter').fadeIn();
                });

                /* Mobile */

                // Open

                $(document).on(clickEvent(), '#site-nav .mobile-search-trigger', function(e) {
                    e.preventDefault();
                    if ( ! $('body').hasClass('mobile-search-is-active') ) {
                        openMobileSearch();
                    }
                });

                // Close on body click

                $(document).on(clickEvent(), 'body.mobile-search-is-active', function(e) {
                    if ( ! $(e.target).parents('#site-search').length ||
                       $(e.target).parents('#site-search .close').length
                    ) {
                        closeMobileSearch();
                    }
                });

                /* Window resize */

                $(window).resize(function() {
                    if (lg) {
                        $('body')
                            .removeClass('mobile-nav-is-active')
                            .removeClass('mobile-search-is-active');
                        closePrimaryNavSubMenus();
                    }

                    // $('#menu-primary > li.menu-item > .sub-menu').each(function() {
                    //     adjustSubMenuWidthAndPosition($(this));
                    // });
                });


                /**
                 * Hero
                 */

                if ( $('.hero').length ) {

                    $('#hero-text').addClass('animated');
                    $('#hero-text strong').addClass('animated');

                }

                // Scroller

                if ( $('body').find('[data-scroller]').length ) {

                    var $scrollerArrow  = $('body').find('[data-scroller="arrow"]'),
                        $scrollerTarget = $($scrollerArrow.attr('href'));

                    $scrollerTarget.addClass('animated');

                    $(document).on(clickEvent(), '.' + $scrollerArrow[0].className, function(e) {
                        e.preventDefault();

                        // Wanted to use velocity here, but 'scroll' doesn't seem to work in 2.0?
                        // https://github.com/julianshapiro/velocity/issues/844
                        $('html, body').animate({
                            scrollTop: $scrollerTarget.offset().top
                        }, 800);
                    });

                    var scrollerWp = new Waypoint({
                        element: document.getElementById($scrollerTarget[0].id),
                        handler: function(direction) {
                            $(this.element).addClass('fade-in-down');
                        },
                        offset: '66%'
                    });

                }

                var sameHeightAllProductTitlesAndImages = function() {
                    // Ensure the product listing titles and images are all the same height.
                    $('.tax-product_category .search-filter-results .row, .home .best-sellers .row, .single-products-alba .related-products .row').each(function() {
                        var minH = 0;

                        var imgContainers = $(this).find('.product-image, .best-seller-image, .related-slide-image');
                        var imgH = imgContainers.find('img').height();

                        // Fix issue where images are really tall on mobile.
                        // if (/*xs &&*/ (imgH > 844 || imgH === 1)) {
                        //     imgContainers.find('a').css('display', 'block');
                        // }

                        imgContainers.css('min-height', '');
                        // imgContainers.find('> a').css('margin-top', '0');
                        imgContainers.each(function() {
                            var h = $(this).outerHeight();
                            if (h > minH) {
                                minH = h;
                            }
                        });

                        // console.log('xs=' + xs + ', imgH=' + imgH);

                        if (minH !== 0) {
                            if (xs && imgH > 400) {
                            }

                            imgContainers.css('min-height', minH + 'px');
                        }

                        // if (/*xs &&*/ (imgH > 844 || imgH === 1)) {
                        //     imgContainers = $(this).find('.product-image, .best-seller-image, .related-slide-image');
                        //     imgContainers.each(function() {
                        //         var h = $(this).height();
                        //         var a = $(this).find('> a');
                        //         console.log('h=' + h + ', a=' + a.height());
                        //         var marginTop = h - a.height();
                        //         if (h > marginTop) {
                        //             a.css('margin-top', marginTop + 'px');
                        //         }
                        //     });
                        // }

                        minH = 0;
                        var h4s = $(this).find('.col-sm-6 h4');
                        h4s.css('min-height', '');

                        // if (!xs) {
                        //     h4s.each(function() {
                        //         var h = $(this).outerHeight();
                        //         if (h > minH) {
                        //             minH = h;
                        //         }
                        //     });

                        //     if (minH !== 0) {
                        //         h4s.css('min-height', minH + 'px');
                        //     }
                        // }
                    });
                };

                setTimeout(sameHeightAllProductTitlesAndImages, 2000);
                window.addEventListener('resize', albaDebounce(function() { setTimeout(sameHeightAllProductTitlesAndImages, 2000); }));

                $(document).on('lazyloaded', function(e){
                    // console.log('sameHeightAllProductTitlesAndImages after lazyload');
                    sameHeightAllProductTitlesAndImages();
                    // Delay a bit and call again for similar products since it seems to be having some issues.
                    setTimeout(sameHeightAllProductTitlesAndImages, 2000);
                });

                $('.filter-toggle').click(function() {
                    $(this).toggleClass('is-open');
                    if ($(this).hasClass('is-open')) {
                        $(this).find('.searchandfilter').slideDown();
                    } else {
                        $(this).find('.searchandfilter').slideUp();
                    }
                });

                AOS.init();
            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired
                /*
                if ( $('.hero').length ) {
                    var heroTextWp = new Waypoint({
                        element: document.getElementById('hero-text'),
                        handler: function(direction) {
                            $(this.element).delay(2000).addClass('fade-in');
                            $(this.element).delay(2500).find('strong').addClass('fade-in-down');
                        },
                        offset: '75%'
                    });
                }
                */
            }

        }, // common

        'home': {

            init: function() {

              // $('.carousel').owlCarousel({
              //     items:         1,
              //     autoplay:      false,
              //     loop:          true,
              //     nav:           true,
              //     dots:          false,
              //     navText:       [
              //         '',
              //         ''
              //     ],
              //     mouseDrag:     true
              // });

                var verticallyCenterTheCenterBuzzImage = function() {
                    var centerImage = $('.center-image');
                    centerImage.css('top', '0');

                    if (xs || sm) {
                        var centerImageH = centerImage.outerHeight();
                        var tH = $('.left-text').innerHeight() - 48;

                        // console.log('centerImageH=' + centerImageH + ', leftTextH=' + tH);
                        if (centerImageH < tH) {
                            centerImage.css('top', ((tH - centerImageH) / 2) + 'px');
                        }
                    }
                };

                window.addEventListener('resize', albaDebounce(verticallyCenterTheCenterBuzzImage));
                verticallyCenterTheCenterBuzzImage();
            }

        },

        'our_story': {
            init: function() {
                var leafInitX = 0;
                var leafInitY = 0;
                var leafDiffX = 0;
                var leafDiffY = 0;
                var leafW = $('.falling-leaf').width();

                $('.falling-leaf').delay(4000).animate(
                    {
                        // left: ['80%', 'easeInSine'],
                        top: (xs)? 300 : 400
                    },
                    {
                        start: function() {
                            $('.falling-leaf').css('opacity', '1');
                        },
                        progress: function(animation, progress, remainingMs) {
                            // console.log('falling-leaf: progress: ', animation, progress, remainingMs);
                            var d = 90 - (110 * progress);
                            var w = leafW - ((leafW / 2) * progress);
                            var l = -30 + (95 * progress);
                            $(this).css('transform', 'rotate('+ d + 'deg)');
                            $(this).css('left', l + '%');
                            $(this).css('height', w + 'px');
                            $(this).css('width', w + 'px');
                        },
                        duration: 2000,
                        easing: 'easeInSine',
                        complete: function(){
                            // console.log('falling-leaf: first anim complete');
                        }
                    }
                ).
                animate(
                    {
                        'text-indent': 300
                    },
                    {
                        start: function(animation) {
                            var hasLeafContainer = $('.has-leaf span').offset();
                            var hasLeafWidth = $('.has-leaf span').width();
                            var current = $(this).offset();
                            leafInitX = current.left;
                            leafInitY = current.top;
                            leafDiffX = (hasLeafContainer.left + hasLeafWidth + 15) - current.left;
                            leafDiffY = (hasLeafContainer.top + ((xs || sm)? 0 : 15)) - current.top;
                            leafW = $('.falling-leaf').width();
                            // console.log('falling-leaf second anim: leafInitX=' + leafInitX + ', leafInitY=' + leafInitY + ', leafDiffX=' + leafDiffX + ', leafInitY=' + leafDiffY);
                        },
                        progress: function(animation, progress, remainingMs) {
                            var hasLeafContainer = $('.has-leaf').offset();
                            var current = $(this).offset();
                            // console.log('falling-leaf: progress: ', animation, progress, remainingMs);
                            var d = -20 + (20 * progress);
                            var w = leafW - ((leafW - 53) * progress);
                            var l = leafInitX + (leafDiffX * progress);
                            var t = leafInitY + (leafDiffY * progress);
                            $(this).css('transform', 'rotate('+ d + 'deg)');
                            $(this).css('left', l + 'px');
                            $(this).css('top', t + 'px');
                            $(this).css('height', w + 'px');
                            $(this).css('width', w + 'px');
                        },
                        duration: 1000,
                        easing: 'easeInSine',
                        complete: function(){
                            $('.falling-leaf').hide();
                            $('.has-leaf').addClass('show-leaf');
                        }
                    }
                );

                $('.our-story .ui-draggable').draggable({
                    handle: '.handler',
                    axis: 'x',
                    containment: 'parent',
                    create: function( event, ui ) {
                        // console.log('create: ', event, ui);
                        $(this).css('left', '50%');
                    },
                    start: function(event, ui) {
                        start = ui.position.left;
                    },
                    drag: function(event, ui) {
                        // console.log('drag: ', event, ui);
                        stop = ui.position.left;
                        var w = $(window).width();
                        var leftPoint = w / 4;
                        var rightPoint = leftPoint * 3;

                        if (stop > rightPoint) {
                            $('.left').addClass('active');
                            $('.right').removeClass('active');
                        } else if ( stop < leftPoint ) {
                            $('.left').removeClass('active');
                            $('.right').addClass('active');
                        } else {
                            $('.left').removeClass('active');
                            $('.right').removeClass('active');
                        }
                        $('.left-out').width(stop+1);
                    }
                });

                // Vertically center content in less than 992px in inner/outer section.

                var innerOuterVerticalTextOnMobile = function() {
                    var innerOuter = $('.inner-outer');
                    var h2Tops = innerOuter.find('h2.top');
                    h2Tops.css('margin-top', '0');

                    if (xs || sm || md) {
                        var innerOuterH = innerOuter.outerHeight(true);
                        h2Tops.each(function() {
                            var contentH = 0;
                            $(this).parent().find('h2.top, .i').each(function() {
                                contentH += $(this).outerHeight(true);
                                // console.log('innerOuterH=' + innerOuterH + ', contentH=' + contentH);
                            });

                            contentH -= 30; // top = 30px for h2.top

                            // console.log('innerOuterH=' + innerOuterH + ', contentH=' + contentH);
                            if (contentH < innerOuterH) {
                                $(this).css('margin-top', ((innerOuterH - contentH) / 2) + 'px');
                            }
                        });
                    }
                };

                window.addEventListener('resize', albaDebounce(innerOuterVerticalTextOnMobile));
                innerOuterVerticalTextOnMobile();
            }
        },

        // Single product page.
        'single': {

            init: function() {
                // Add a class to the tab content for which tab was clicked so we can alter the border radius.
                $('#product-tab-content').addClass('active-tab-0');
                $('#product-tabs a').click(function() {
                    var idx = $('#product-tabs li').index($(this).parent());
                    $('#product-tab-content').removeClass('active-tab-0 active-tab-1 active-tab-2 active-tab-3').addClass('active-tab-' + idx);
                });

                $('.tell-me-more').click(function() {
                    var hash = this.hash;
                    $('html, body').animate({ scrollTop: $(hash).offset().top - 50 }, 800, function(){
                        // window.location.hash = hash;
                    });

                    return false;
                });

                // Title move
                /*
                var moveTitle = function() {
                    if ( ! md ) {
                        $('.single-header').prependTo('.col-single-imagery');
                    } else {
                        $('.single-header').prependTo('.single-content');
                    }
                };

                if ( $('.single-header').length ) {

                    moveTitle();

                    $(window).resize(function() {
                        moveTitle();
                    });

                }

                // Product certs

                if ( $('#certs-list').length ) {

                    var $certsList = $('#certs-list');

                    $certsList.addClass('animated');

                    var certsListWp = new Waypoint({
                        element: document.getElementById('certs-list'),
                        handler: function(direction) {
                            $(this.element).addClass('fade-in-up');
                        },
                        offset: '75%'
                    });

                }

                // Buy now

                if ( $('.buy-now').length ) {

                    var $buyNow = $('.buy-now');

                    $buyNow.addClass('animated');

                    var buyNowWp = new Waypoint({
                        element: document.getElementById('buy-now'),
                        handler: function(direction) {
                            $(this.element).addClass('fade-in-down');
                        },
                        offset: '75%'
                    });

                }
                */
                // Carousels
            }

        },

        'contact_us': {
            init: function() {
                // Add placeholders to the contact us form.
                $('#contact-us-form .field label + input').each(function() {
                    var prev = $(this).prev();
                    prev.hide();
                    $(this).attr('placeholder', prev.text().replace(':', ''));
                });

                $('#contact-us-form .field label + select').each(function() {
                    var prev = $(this).prev();
                    prev.hide();
                });

                // Change some text in the contact us form.
                var h2 = $('#contact-us-form fieldset h2:eq(0)').html();
                h2 = h2.replace('Your Information', 'Your Informations');
                h2 = h2.replace('Bolded fields are required', 'Bold fields are required');
                $('#contact-us-form fieldset h2:eq(0)').html(h2);
            }
        },

        'locate_stores': {
            init: function() {
                var resizeDestiniIFrame = function() {
                    if (xs) {
                        $('#storelocator_script > iframe').css('height', '8600px');
                    } else if (sm) {
                        $('#storelocator_script > iframe').css('height', '7927px');
                    } else if (md) {
                        $('#storelocator_script > iframe').css('height', '8177px');
                    } else if (lg) {
                        $('#storelocator_script > iframe').css('height', '7759px');
                    } else if (xl) {
                        $('#storelocator_script > iframe').css('height', '7759px');
                    }
                };

                window.addEventListener('resize', albaDebounce(resizeDestiniIFrame));
                resizeDestiniIFrame();
            }
        },
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Delta;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

   /* // Load Events
    $(document).ready(UTIL.loadEvents);

    $('.image-toggler').click(function(){
        $('.image-toggle').hide();
        $('.single-imagery:visible img.' + $(this).attr('data-image')).show();

        if (xs) {
            $('html, body').animate({
                scrollTop: $('.single-imagery:visible').offset().top - 50
            }, 800);
        }
    });

    $(".expandableCollapsibleDiv > .privacy-title").click(function (e) {
      var showElementDescription =
        $(this).parents(".expandableCollapsibleDiv").find(".privacy-body");

      if ($(showElementDescription).is(":visible")) {
        showElementDescription.hide("fast", "swing");
      } else {
        showElementDescription.show("fast", "swing");
      }
    });
})(jQuery); // Fully reference jQuery after this point.
*/
  // Load Events
  $(document).ready(UTIL.loadEvents);

  $('.image-toggler').click(function(){
    $('.image-toggle').hide();
    $('.single-imagery:visible img.' + $(this).attr('data-image')).show();

    if (xs) {
      $('html, body').animate({
        scrollTop: $('.single-imagery:visible').offset().top - 50
      }, 800);
    }
  });

  $(".expandableCollapsibleDiv > .privacy-title").click(function (e) {
    var showElementDescription = $(this).parents(".expandableCollapsibleDiv").find(".privacy-body");

    if ($(showElementDescription).is(":visible")) {
      showElementDescription.hide("fast", "swing");
      $(this).removeClass('open');
    } else {
      showElementDescription.show("fast", "swing");
      $(this).addClass('open');
    }
  });
})(jQuery); // Fully reference jQuery after this point.


function openProductModal() {
  document.getElementById("myProdModal").style.display = "block";
}

function closeProductModal() {
  document.getElementById("myProdModal").style.display = "none";
}

var slideIndexProd = 1;

function showProductSlides(n) {
  var i;
  var slidesss = document.getElementsByClassName("mySlidespro");
  var dotsss = document.getElementsByClassName("demopro");
  if (n > slidesss.length) {slideIndexProd = 1;}
  if (n < 1) {slideIndexProd = slidesss.length;}
  for (i = 0; i < slidesss.length; i++) {
    slidesss[i].style.display = "none";
  }
  for (i = 0; i < dotsss.length; i++) {
    dotsss[i].className = dotsss[i].className.replace(" active", "");
  }
  if(slidesss && slidesss[slideIndexProd-1]){
    slidesss[slideIndexProd-1].style.display = "block";
  }
  if(dotsss && dotsss[slideIndexProd-1]){
    dotsss[slideIndexProd-1].className += " active";
  }

}


function plusProdSlides(n) {
  showProductSlides(slideIndexProd += n);
}

function currentProdSlide(n) {
  showProductSlides(slideIndexProd = n);
}

showProductSlides(slideIndexProd);


var slideIndexMod = 1;

function showModSlides(n) {
  var i;
  var modSlides = document.getElementsByClassName("mySlidesMod");
  var modDots = document.getElementsByClassName("demoMod");
  if (n > modSlides.length) {slideIndexMod = 1;}
  if (n < 1) {slideIndexMod = modSlides.length;}
  for (i = 0; i < modSlides.length; i++) {
    modSlides[i].style.display = "none";
  }
  for (i = 0; i < modDots.length; i++) {
    modDots[i].className = modDots[i].className.replace(" active", "");
  }
  if(modSlides && modSlides[slideIndexMod-1]){
    modSlides[slideIndexMod-1].style.display = "block";
  }
  if(modDots && modDots[slideIndexMod-1]){
    modDots[slideIndexMod-1].className += " active";
  }
}

function plusModSlides(n) {
  showModSlides(slideIndexMod += n);
}

function currentModSlide(n) {
  showModSlides(slideIndexMod = n);
}

showModSlides(slideIndexMod);

//  Product Zoom
/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function ($) {
  var defaults = {
    url: false,
    callback: false,
    target: false,
    duration: 120,
    on: 'mouseover', // other options: grab, click, toggle
    touch: true, // enables a touch fallback
    onZoomIn: false,
    onZoomOut: false,
    magnify: 1
  };

  // Core Zoom Logic, independent of event listeners.
  $.zoom = function(target, source, img, magnify) {
    var targetHeight,
      targetWidth,
      sourceHeight,
      sourceWidth,
      xRatio,
      yRatio,
      offset,
      $target = $(target),
      position = $target.css('position'),
      $source = $(source);

    // The parent element needs positioning so that the zoomed element can be correctly positioned within.
    target.style.position = /(absolute|fixed)/.test(position) ? position : 'relative';
    target.style.overflow = 'hidden';
    img.style.width = img.style.height = '';

    $(img)
      .addClass('zoomImg')
      .css({
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: 0,
        width: img.width * magnify,
        height: img.height * magnify,
        border: 'none',
        maxWidth: 'none',
        maxHeight: 'none'
      })
      .appendTo(target);

    return {
      init: function() {
        targetWidth = $target.outerWidth();
        targetHeight = $target.outerHeight();

        if (source === target) {
          sourceWidth = targetWidth;
          sourceHeight = targetHeight;
        } else {
          sourceWidth = $source.outerWidth();
          sourceHeight = $source.outerHeight();
        }

        xRatio = (img.width - targetWidth) / sourceWidth;
        yRatio = (img.height - targetHeight) / sourceHeight;

        offset = $source.offset();
      },
      move: function (e) {
        var left = (e.pageX - offset.left),
          top = (e.pageY - offset.top);

        top = Math.max(Math.min(top, sourceHeight), 0);
        left = Math.max(Math.min(left, sourceWidth), 0);

        img.style.left = (left * -xRatio) + 'px';
        img.style.top = (top * -yRatio) + 'px';
      }
    };
  };

  $.fn.zoom = function (options) {
    return this.each(function () {
      var
        settings = $.extend({}, defaults, options || {}),
        //target will display the zoomed image
        target = settings.target && $(settings.target)[0] || this,
        //source will provide zoom location info (thumbnail)
        source = this,
        $source = $(source),
        img = document.createElement('img'),
        $img = $(img),
        mousemove = 'mousemove.zoom',
        clicked = false,
        touched = false;

      // If a url wasn't specified, look for an image element.
      if (!settings.url) {
        var srcElement = source.querySelector('img');
        if (srcElement) {
          settings.url = srcElement.getAttribute('data-src') || srcElement.currentSrc || srcElement.src;
        }
        if (!settings.url) {
          return;
        }
      }

      $source.one('zoom.destroy', function(position, overflow){
        $source.off(".zoom");
        target.style.position = position;
        target.style.overflow = overflow;
        img.onload = null;
        $img.remove();
      }.bind(this, target.style.position, target.style.overflow));

      img.onload = function () {
        var zoom = $.zoom(target, source, img, settings.magnify);

        function start(e) {
          zoom.init();
          zoom.move(e);

          // Skip the fade-in for IE8 and lower since it chokes on fading-in
          // and changing position based on mousemovement at the same time.
          $img.stop()
            .fadeTo($.support.opacity ? settings.duration : 0, 1, $.isFunction(settings.onZoomIn) ? settings.onZoomIn.call(img) : false);
        }

        function stop() {
          $img.stop()
            .fadeTo(settings.duration, 0, $.isFunction(settings.onZoomOut) ? settings.onZoomOut.call(img) : false);
        }

        // Mouse events
        if (settings.on === 'grab') {
          $source
            .on('mousedown.zoom',
              function (e) {
                if (e.which === 1) {
                  $(document).one('mouseup.zoom',
                    function () {
                      stop();

                      $(document).off(mousemove, zoom.move);
                    }
                  );

                  start(e);

                  $(document).on(mousemove, zoom.move);

                  e.preventDefault();
                }
              }
            );
        } else if (settings.on === 'click') {
          $source.on('click.zoom',
            function (e) {
              if (clicked) {
                // bubble the event up to the document to trigger the unbind.
                return;
              } else {
                clicked = true;
                start(e);
                $(document).on(mousemove, zoom.move);
                $(document).one('click.zoom',
                  function () {
                    stop();
                    clicked = false;
                    $(document).off(mousemove, zoom.move);
                  }
                );
                return false;
              }
            }
          );
        } else if (settings.on === 'toggle') {
          $source.on('click.zoom',
            function (e) {
              if (clicked) {
                stop();
              } else {
                start(e);
              }
              clicked = !clicked;
            }
          );
        } else if (settings.on === 'mouseover') {
          zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

          $source
            .on('mouseenter.zoom', start)
            .on('mouseleave.zoom', stop)
            .on(mousemove, zoom.move);
        }

        // Touch fallback
        if (settings.touch) {
          $source
            .on('touchstart.zoom', function (e) {
              e.preventDefault();
// 							if (touched) {
// 								touched = false;
// 								stop();
// 							} else {
// 								touched = true;
// 								start( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
// 							}
              openProductModal();
            })
            .on('touchmove.zoom', function (e) {
              e.preventDefault();
              openProductModal();
              //zoom.move( e.originalEvent.touches[0] || e.originalEvent.changedTouches[0] );
            })
            .on('touchend.zoom', function (e) {
              e.preventDefault();
// 							if (touched) {
// 								touched = false;
// 								stop();
// 							}
              openProductModal();
            });
        }

        if ($.isFunction(settings.callback)) {
          settings.callback.call(img);
        }
      };

      img.setAttribute('role', 'presentation');
      img.alt = '';
      img.src = settings.url;
    });
  };

  $.fn.zoom.defaults = defaults;

  $('#ex1').zoom();
  $('#ex2').zoom();
  $('#ex3').zoom();
  $('#ex4').zoom();
  $('#ex5').zoom();
  $('#ex6').zoom();

}(window.jQuery));
